import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import { PanesPad } from 'modules/core/components/PanesPad'
import Toggler from 'modules/core/components/Toggler'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type { AutomationCreator } from 'modules/automations/lib/ShowRouteContextParams'
import type { Automation } from 'modules/automations/store/models/Automation'

import './index.styles.css'
interface Props {
  automation: Automation
  automationCreator?: AutomationCreator
  toggleEnabled: () => void
}

const EMPTY_TEXT = '-'

export const Title = observer(({ automation, automationCreator, toggleEnabled }: Props) => {
  const createdBy = () => {
    if (!!automation.attributes.slug) return 'Factorial' // eslint-disable-line no-extra-boolean-cast

    return automationCreator
      ? getFullDisplayName({
          firstName: automationCreator.firstName,
          lastName: automationCreator.lastName,
        })
      : EMPTY_TEXT
  }

  const createdByLabel = createdBy()

  return (
    <PanesPad>
      <PanesHeader title={i18n.t('automations.show.details.title')} separation />
      <div>
        <div className={'Title_toggler'}>
          <div className={'Title_togglerContainer'}>
            <Toggler
              disabled={false}
              active={automation.attributes.enabled}
              type="correct"
              onChange={toggleEnabled}
            />
          </div>
          <Text.Normal>
            {automation.attributes.enabled
              ? i18n.t('automations.show.details.enabled')
              : i18n.t('automations.show.details.disabled')}
          </Text.Normal>
        </div>
        <div className={'Title_text'}>
          <div>
            <Text.Normal weight="semibold" size="200">
              {i18n.t('automations.automation.created_by')}
            </Text.Normal>
          </div>
          <div>
            <Text.Normal color={createdByLabel === EMPTY_TEXT ? 'grey1000' : 'grey800'}>
              {createdByLabel}
            </Text.Normal>
          </div>
        </div>
      </div>
    </PanesPad>
  )
})
